import { Box } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { EditButton, FormTab, Show, ShowProps, TabbedForm, usePermissions, useRedirect, useShowController } from 'react-admin';
import { User } from '../../types/user';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import UserGeneralTab from './GeneralTab';
import SecurityTab from './SecurityTab';
import TicketsTab from './TicketsTab';
import ReplyIcon from '@material-ui/icons/Reply';
import CreditTab from './CreditTab';
import { checkPermission } from '../../helpers/checkPermissions';
import ReferralTab from './ReferralTab';
import { CouponTab } from './CouponTab';


const ShowUser: FC<ShowProps> = (props) => {
    const {permissions} = usePermissions()
    const controllerProps = useShowController<User>(props)
    const id = props.id ? props.id : controllerProps.record?._id
    const redirect = useRedirect()
    const [state, setState] = useState({
        isBlocked: false
    })

    const changeStatus = () => {
        setState({ ...state, isBlocked: !state.isBlocked })
    }

    const toList = () => {
        redirect('/users')
    }

    return (
        <>
            <DocumentTitle core="User" secondary="Users" purpose={`${controllerProps.record?.name}`} appointment={`${controllerProps.record?.surname}`} />
            <Box position="relative">
                <div className="back-icon">
                        <ReplyIcon onClick={toList} />
                </div>
                <Show {...props} hasEdit={checkPermission(permissions, "User management", "Update")}>
                    <TabbedForm className="user-tabs" toolbar={<CustomToolbar />}>
                        <FormTab label="General">
                            <UserGeneralTab isBlocked={state.isBlocked} changeStatus={changeStatus} isShow={true} />
                        </FormTab>
                        <FormTab label="Security & Notifications">
                            <SecurityTab
                                id={controllerProps.record?._id ? controllerProps.record?._id : ''}
                                notifications={controllerProps.record?.notifications}
                                user={controllerProps.record}
                                isShow={true}
                            />
                        </FormTab>
                        <FormTab label="Tickets">
                            <TicketsTab
                                 id={id || ''}
                                 isShow={true}
                                 props={props}
                            />
                        </FormTab>
                        <FormTab label="Credit">
                        <CreditTab
                            id={controllerProps.record?._id ? controllerProps.record?._id : ''}
                            isShow={true}
                        />
                    </FormTab>
                    <FormTab label="Referral">
                        <ReferralTab id={id || ''} isView={true} />
                    </FormTab>
                    <FormTab label="Coupon">
                        <CouponTab id={id || ""} isView={true} />
                    </FormTab>
                    </TabbedForm>
                </Show>
            </Box>
        </>
    )
}

const CustomToolbar = () => {
    return (
        <>
        </>
    )
}

export default ShowUser